<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
        <Input v-model="params.importFileName" placeholder="请输入导入文件名"></Input>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
        <Input v-model="params.importerName" placeholder="请输入导入人姓名"></Input>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="8" :xs="24" class="margin-bottom">
        <sl-select value-type="string" placeholder="请选择导入类型" :data="types" v-model="params.type" />
        </Col>
        <Col span="6" :lg="6" :md="24" :sm="24" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button @click="reset()">清空</Button>
        </div>
        <div>
          <!-- <Button type="primary" class="margin-right" icon="md-add"" @click=" create()">新增</Button> -->
          <!-- <Button :disabled="removeDisable" type="error" icon="md-trash" @click="remove()">删除</Button> -->
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :show-header="false" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
  </sl-page>
</template>
<script>
import block from './block'
export default {
  components: {},
  data() {
    return {
      columns: [{
          minWidth: 300,
          // maxWidth: 550,
          render: (h, { row }) => {
            return h(block, { props: { data: row } })
          }
        }
      ],
      data: [],
      params: {
        importerName: null,
        importFileName: null,
        type: null
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      modalVisible: false,
      selection: [],
      types: []
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    }
  },
  created() {
    this.def = { ...this.params }
    
    this.$request.kv('excel_import_type').then(resp => {
      this.types = resp.data.map(i => ({ value: i.cKey, label: i.cValue }))
      this.list()
    })
  },

  methods: {

    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.impt(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list, { 'state': '$partsState', 'type': this.types, 'importDatetime': 'datetime' })

          this.page.total = resp.data.total || 0
        }
      })
    },

    edit({ row }) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init(0)
    },

    remove({ row }) {
      let params = row.id // { ids: this.selection }
      let tips = row.state == 1 ? '该部件正在APP中展示，确定删除吗？' : '确定删除吗？'
      this.$ui.confirm(this.$request.partsDelete, tips)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('删除成功')
          this.selection = []
          this.list()
        }
      })
    },

    handleUpdate() {
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    },

    $update() {
      this.list()
    },

    handleSort(data) {

    },

    toggle(data) {
      let params = data.id
      let tip = data.state ? `确定取消展示 ${data.name}吗？` : `确定展示 ${data.name}吗？`
      this.$ui.confirm(this.$request.partsToggle, tip)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.list()
        } else {
          this.$Message.error({ content: resp.msg || '操作失败' })
        }
      })
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },
  }
}

</script>
